import * as Types from '../../../.cache/__types__/index';

import { gql } from '@apollo/client';
import { BillingSubscriptionProductDetailsFragmentDoc } from './product.graphql';
export type BillingSubscriptionPriceDetailsFragment = { __typename?: 'BillingSubscriptionPrice', id: string, display_name?: string | null, unit_amount: number, currency: string, interval: string, stripe_price_id?: string | null, subscription_type?: Types.BillingSubscriptionType | null, is_current?: boolean | null, product?: { __typename?: 'BillingSubscriptionProduct', type?: Types.WorkspaceType | null, display_name?: string | null, trial_period_days?: number | null, min_card_count?: number | null, max_card_count?: number | null, is_current?: boolean | null, provider: Types.BillingSubscriptionProvider } | null };

export const BillingSubscriptionPriceDetailsFragmentDoc = gql`
    fragment BillingSubscriptionPriceDetails on BillingSubscriptionPrice {
  id
  display_name
  unit_amount
  currency
  interval
  stripe_price_id
  product {
    ...BillingSubscriptionProductDetails
  }
  subscription_type
  is_current
}
    ${BillingSubscriptionProductDetailsFragmentDoc}`;